import { useState } from 'react';
import { 
  Card,
  Title,
  Text,
  Switch,
  Button
} from '@mantine/core';
import EmailEditor from './EmailEditor';
import { useDisclosure } from "@mantine/hooks";
import { IconMail } from '@tabler/icons-react';

export default function FollowOnEmail({evt, handler}) {
  const [followOn, setFollowOn] = useState(evt.followOn);
  const [opened, {open, close}] = useDisclosure(false);
  const text = 'Please provide the content which will be sent to a ticket buyer immediately after they purchase a ticket';
  const field = 'follow_on_body';

  return (
    <Card withBorder shadow="sm" padding="lg" mb={20} style={{height: '100%'}}>
      <Title order={3}>Follow On E-Mail</Title>
      <Switch
        size="lg"
        onLabel="Yes"
        offLabel="No"
        color="orange"
        label="Send e-mail to ticket buyer immediately after purchase?"
        checked={followOn}
        onChange={(event) => { setFollowOn(event.currentTarget.checked); handler('follow_on', event.currentTarget.checked.toString());}}
        my={20}
      />

      <Text my={20}>This email does not have auto-generated content. Use the editor button below to compose the content.</Text>
      <Button color="orange" onClick={open} leftIcon={<IconMail />}>Open Editor</Button>
      <EmailEditor opened={opened} handler={handler} field={field} text={text} close={close} content={evt.followOnBody} />
    </Card>
  )
}